import axios from 'axios';

const version = '/api/v1';

export default {
  getOrgs() {
    return axios({
      method: 'get',
      url: `${version}/org`,
    });
  },
  getInviteCode(orgId) {
    return axios({
      method: 'get',
      url: `${version}/org/${orgId}/invite`,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/orgs/api.js